import { apiClient } from "@/shared/api/client";

export type NikolaTopupPackId = "credits_500" | "credits_1000" | "credits_2000";
const returnUrl = (state: "success" | "cancelled") => `${window.location.origin}/subscription?billing=${state}`;

export const startClubCheckout = async (planId: "club_monthly" | "club_yearly"): Promise<void> => {
  const session = await apiClient<{ url: string }>("/stripe/checkout", {
    method: "POST",
    body: JSON.stringify({ planId, successUrl: returnUrl("success"), cancelUrl: returnUrl("cancelled") }),
  });
  window.location.assign(session.url);
};

export const startNikolaTopup = async (packId: NikolaTopupPackId): Promise<void> => {
  const session = await apiClient<{ url: string }>("/stripe/credits/checkout", {
    method: "POST",
    body: JSON.stringify({
      packId,
      successUrl: `${window.location.origin}/subscription?credits=success`,
      cancelUrl: `${window.location.origin}/subscription?credits=cancelled`,
    }),
  });
  window.location.assign(session.url);
};

export const switchToClubYearly = (): Promise<{ updated: true }> =>
  apiClient("/stripe/change-plan", {
    method: "POST",
    body: JSON.stringify({ planId: "club_yearly" }),
  });

export const openBillingPortal = async (): Promise<void> => {
  const session = await apiClient<{ url: string }>("/stripe/portal", {
    method: "POST",
    body: JSON.stringify({ returnUrl: `${window.location.origin}/subscription` }),
  });
  window.location.assign(session.url);
};
